"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _contentHelpers = _interopRequireDefault(require("../../helpers/contentHelpers"));

var _LinkedContentMapper = _interopRequireDefault(require("../LinkedContentMapper/LinkedContentMapper"));

var _KeyPointsListItems = _interopRequireDefault(require("./components/KeyPointsListItems"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var keyPointsConfig = {
  hyperlink: 'WithExternalLinkIcon',
  embed: 'inline'
};
/* eslint-disable camelcase */

var KeyPoints = function KeyPointsComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData,
      linkedContent = _ref.linkedContent;
  var linkedContentData = (0, _contentHelpers["default"])(sliceData, linkedContent);
  var slice_label = sliceData.slice_label,
      items = sliceData.items,
      _sliceData$primary = sliceData.primary,
      background_color = _sliceData$primary.background_color,
      key_points_title = _sliceData$primary.key_points_title;
  var backgroundColor = background_color;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "key-points-wrapper",
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "key-points"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "key-points-title-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "key-points-body__heading-2"
  }, dataClient.textToMarkdown(key_points_title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "key-points-body-col"
  }, /*#__PURE__*/_react["default"].createElement(_KeyPointsListItems["default"], {
    sliceLabel: slice_label,
    dataClient: dataClient,
    keyPointsConfig: keyPointsConfig,
    items: items
  }), /*#__PURE__*/_react["default"].createElement(_LinkedContentMapper["default"], {
    linkedContentData: linkedContentData,
    dataClient: dataClient
  })))));
};

KeyPoints.propTypes = {
  dataClient: _propTypes["default"].shape({
    slice_label: _propTypes["default"].string,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    primary: _propTypes["default"].shape({
      background_color: _propTypes["default"].string,
      key_points_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    })
  }).isRequired,
  sliceData: _propTypes["default"].shape({}).isRequired,
  linkedContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
KeyPoints.defaultProps = {
  linkedContent: null
};
var _default = KeyPoints;
exports["default"] = _default;